import BannerBG from "../components/BannerComponents/BannerBG";
import React from 'react';
import Search from '../components/SearchBar/Search';
import Banner2 from "../components/BannerComponents/Banner2";

export default function Home() {
  function pass(){
    console.log("pass")
  }
  function fail(){
    console.log("fail")
  }
   

  return (
    <div>
      <BannerBG bannerBG='defaultBannerBG'>
        <Banner2 title='Inn-Sight Hotel Booking' subtitle='Seeing where to Sleep'>
         <Search fail={fail} pass = {pass}/>
        </Banner2>
      </BannerBG>
    
    </div>
      
  )
}
